<template>
  <div class="part5-wrap" :class="{'part5-none':!flag}">
    <template v-if="renderFlag">
      <div class="title-wrap">
        <v-title class="title" :text="'我们的案例'"></v-title>
      </div>
      <div ref="half_cir" class="half-cir">
        <div class="ball ball_1"  :class="{'ball-in':showIndex === 0}" @mouseenter="mouseEnter(0)">
          <div class="ball-inner">
            <i class="iconfont icon-qianbao"></i>
          </div>
        </div>
        <div class="ball ball_2"  :class="{'ball-in':showIndex === 1}" @mouseenter="mouseEnter(1)">
          <div class="ball-inner">
            <i class="iconfont icon-lianjie"></i>
          </div>
        </div>
        <div class="ball ball_3"  :class="{'ball-in':showIndex === 2}" @mouseenter="mouseEnter(2)">
          <div class="ball-inner">
            <i class="iconfont icon-moxing"></i>
          </div>
        </div>
        <div class="ball ball_4"  :class="{'ball-in':showIndex === 3}" @mouseenter="mouseEnter(3)">
          <div class="ball-inner">
            <i class="iconfont icon-yingyongicon-"></i>
          </div>
        </div>
        <div class="ball ball_5"  :class="{'ball-in':showIndex === 4}" @mouseenter="mouseEnter(4)">
          <div class="ball-inner">
            <i class="iconfont icon-ai35"></i>
          </div>
        </div>
        <div class="ball ball_6"  :class="{'ball-in':showIndex === 5}" @mouseenter="mouseEnter(5)">
          <div class="ball-inner">
            <i class="iconfont icon-jiaoyiguanliicon"></i>
          </div>
        </div>
        <div ref="half_cir_inner" class="half-cir-inner">
          <h1><i class="iconfont" :class="list[showIndex].icon"></i></h1>
          <h2>{{list[showIndex].title}}</h2>
          <p>{{list[showIndex].con}}</p>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="title-wrap">
        <v-title class="title" :text="'我们的案例'"></v-title>
      </div>
      <div ref="half_cir" class="half-cir">
        <div class="ball ball_1"  :class="{'ball-in':showIndex === 0}" @mouseenter="mouseEnter(0)">
          <div class="ball-inner">
            <i class="iconfont icon-qianbao"></i>
          </div>
        </div>
        <div class="ball ball_2"  :class="{'ball-in':showIndex === 1}" @mouseenter="mouseEnter(1)">
          <div class="ball-inner">
            <i class="iconfont icon-lianjie"></i>
          </div>
        </div>
        <div class="ball ball_3"  :class="{'ball-in':showIndex === 2}" @mouseenter="mouseEnter(2)">
          <div class="ball-inner">
            <i class="iconfont icon-moxing"></i>
          </div>
        </div>
        <div class="ball ball_4"  :class="{'ball-in':showIndex === 3}" @mouseenter="mouseEnter(3)">
          <div class="ball-inner">
            <i class="iconfont icon-yingyongicon-"></i>
          </div>
        </div>
        <div class="ball ball_5"  :class="{'ball-in':showIndex === 4}" @mouseenter="mouseEnter(4)">
          <div class="ball-inner">
            <i class="iconfont icon-ai35"></i>
          </div>
        </div>
        <div class="ball ball_6"  :class="{'ball-in':showIndex === 5}" @mouseenter="mouseEnter(5)">
          <div class="ball-inner">
            <i class="iconfont icon-jiaoyiguanliicon"></i>
          </div>
        </div>
        <div ref="half_cir_inner" class="half-cir-inner">
          <h1><i class="iconfont" :class="list[showIndex].icon"></i></h1>
          <h2>{{list[showIndex].title}}</h2>
          <p>{{list[showIndex].con}}</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import VTitle from "../plug/VTitle";
  import bus from '../../assets/js/bus';

  export default {
    components: {VTitle},
    name: "part5",
    props: ['flag','renderFlag'],
    data() {
      return {
        showIndex: 0,
        list: [
          {
            title:'区块链中间件',
            con:'通过统一封装的接口，将现存区块链间的接口差异抹除。协助区块链产品快速开发上线。支持多币种接入和归账汇总。',
            icon: 'icon-qianbao'
          },
          {
            title:'区块链+借贷项目',
            con:'与金融公司合作，将P2P借贷数据上链.支持多种上链模式，数据直接上链、数据hash上链、数据可删除式上链等。',
            icon: 'icon-lianjie'
          },
          {
            title:'多资产区块链实现',
            con:'通过高性能区块链并支持原生多资产和合约资产，完美释放了多资产的应用潜力。',
            icon: 'icon-moxing'
          },
          {
            title:'UTXO模型智能合约区块链',
            con:'基于UTXO模型的带有智能合约的区块链产品。并支持定制sha256、scrypt、equihash、blake256等多种挖矿算法及多种共识POW、POS、DPOS等。',
            icon: 'icon-yingyongicon-'
          },
          {
            title:'云存储区块链开发',
            con:'基于DPOS协议，由智能合约控制链上存储的文件的访问权限和收费。通过图灵完备的智能合约真正实现数据的授权式共享。',
            icon: 'icon-ai35'
          },
          {
            title:'跨链交易支持',
            con:'以跨链技术，建立起现存区块链间的价值交换渠道,将更好地支撑现存区块链的应用生态。',
            icon: 'icon-jiaoyiguanliicon'
          }
        ]
      };
    },
    mounted() {
      this.targetInit();
      let that = this;
      bus.$on('resize',function () {
        that.targetInit();
      });
    },
    methods: {
      mouseEnter(index) {
        this.showIndex = index;
      },
      targetInit() {
        let target = this.$refs.half_cir;
        let height = target.offsetWidth;
        target.style.height = height - 2 + 'px';

        let target_inner = this.$refs.half_cir_inner;
        let height_inner = target_inner.offsetWidth;
        target_inner.style.height = height_inner + 'px';

        let center_left = (target.offsetWidth +2) / 2;
        let target_balls = document.getElementsByClassName('ball');
        let line_height = target_balls[0].offsetHeight;
        for (let i = 0; i < target_balls.length; i++) {
          target_balls[i].style.transformOrigin = center_left + line_height / 2 + 'px center';
          target_balls[i].style.lineHeight = line_height + 'px';
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .part5-wrap {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    background: url("../../assets/img/part5-bg.jpg");
    background-size: 100% 100%;
    color: white;
    .title-wrap {
      height: 18%;
      position: relative;
      .title {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .half-cir {
      width: 68%;
      border-radius: 50%;
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translate(-50%, 50%);
      border: 1px solid #999999;
      .ball {
        width: 10%;
        height: 10%;
        text-align: center;
        position: absolute;
        border-radius: 50%;
        left: 0;
        top: 50%;
        transform: translate(-50%, -50%);
        background: white;
        cursor: pointer;
        .iconfont {
          color: #333333;
          font-size: 5em;
          vertical-align: middle;
        }
      }
      .ball_1 {
        transform: translate(-50%, -50%) rotate(15deg);
        .ball-inner {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          text-align: center;
          transform: rotate(-15deg);
        }
      }
      .ball_2 {
        transform: translate(-50%, -50%) rotate(45deg);
        .ball-inner {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          text-align: center;
          transform: rotate(-45deg);
          .iconfont {
            font-size: 7em;
          }
        }
      }
      .ball_3 {
        transform: translate(-50%, -50%) rotate(75deg);
        .ball-inner {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          text-align: center;
          transform: rotate(-75deg);
          .iconfont {
            font-size: 6em;
          }
        }
      }
      .ball_4 {
        transform: translate(-50%, -50%) rotate(105deg);
        .ball-inner {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          text-align: center;
          transform: rotate(-105deg);
        }
      }
      .ball_5 {
        transform: translate(-50%, -50%) rotate(135deg);
        .ball-inner {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          text-align: center;
          transform: rotate(-135deg);
          .iconfont {
            font-size: 7em;
          }
        }
      }
      .ball_6 {
        transform: translate(-50%, -50%) rotate(165deg);
        .ball-inner {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          text-align: center;
          transform: rotate(-165deg);
          .iconfont {
            font-size: 6em;
          }
        }
      }
      .ball-in {
        background: #0AD3FD;
        .iconfont {
          color: white;
        }
      }
      .half-cir-inner {
        width: 75%;
        text-align: center;
        border-radius: 50%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: white;
        background: rgba(0, 0, 0, .4);
        h1 {
          margin-top: 5%;
          .iconfont {
            font-size: 4em;
          }
        }
        h2 {
          font-size: 2rem;
          margin-top: 20px;
        }
        p {
          width: 65%;
          margin: 5% auto;
          font-size: 1.25rem;
        }
      }
    }
  }

  .part5-none {
    background: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/part5/Part5.vue